import React from 'react'
import PropTypes from 'prop-types'

import './style.css.scss'

const SCROLL_STEP = 6

class Description extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      scrollTop: 0,
      scrollHeight: 0,
      offsetHeight: 0
    }
    this.scrollUpInterval = null
    this.scrollDownInterval = null
  }

  componentDidMount() {
    const { scrollTop, offsetHeight, scrollHeight } = this.descriptionContainer
    this.setState({
      scrollTop,
      offsetHeight,
      scrollHeight
    })
  }

  handleScrollUp = () => {
    this.scrollUpInterval = setInterval(() => {
      this.descriptionContainer.scrollTo(
        0,
        this.descriptionContainer.scrollTop - SCROLL_STEP
      )
    }, 100);
  }

  handleScrollDown = () => {
    this.scrollDownInterval = setInterval(() => {
      this.descriptionContainer.scrollTo(
        0,
        this.descriptionContainer.scrollTop + SCROLL_STEP
      )
    }, 100);
  }

  stopScrollUp = () => {
    clearInterval(this.scrollUpInterval);
    this.setState({
      scrollTop: this.descriptionContainer.scrollTop
    })
  }

  stopScrollDown = () => {
    clearInterval(this.scrollDownInterval);
    this.setState({
      scrollTop: this.descriptionContainer.scrollTop
    })
  }

  renderScrollArrows = () => {
    const { scrollTop, scrollHeight, offsetHeight } = this.state
    const isArrowDownDisabled = scrollTop + offsetHeight >= scrollHeight

    return(
      <div className='custom-scroll'>
        <span
          className={`icon-full-arrow-up-centered ${scrollTop == 0 ? 'disabled' : ''}`}
          onMouseOver={this.handleScrollUp}
          onMouseOut={this.stopScrollUp}/>
        <span
          className={`icon-full-arrow-down-centered ${isArrowDownDisabled ? 'disabled' : ''}`}
          onMouseOver={this.handleScrollDown}
          onMouseOut={this.stopScrollDown}/>
      </div>
    )
  }

  render() {
    const { children, themeColorHex, className} = this.props
    const style = {backgroundColor: themeColorHex}
    const { scrollHeight, offsetHeight } = this.state

    return (
      <div
        className={`description-container ${className}`} style={style}>
        <div className="description-content">
          <div
            className="content-container"
            ref={ref => this.descriptionContainer = ref}>
              {children}
            {scrollHeight > offsetHeight && this.renderScrollArrows()}
           </div>
        </div>
      </div>
    )
  }
}

Description.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  className: PropTypes.string
}

export default Description
